exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".User-module__wrapper___7HBda{display:grid;grid-template-columns:auto 1fr auto;gap:1rem;justify-content:start;align-items:center;padding:.35rem .5rem;border-radius:3px;cursor:pointer;transition:.2s}.User-module__wrapper___7HBda:hover{background-color:#ececec!important}.User-module__wrapper___7HBda b,.User-module__wrapper___7HBda strong{font-weight:700}", ""]);

// exports
exports.locals = {
	"wrapper": "User-module__wrapper___7HBda"
};